<template>
  <v-container class="inner-main pt-2 mb-10">
    <v-row class="mx-0">
      <h2>{{$t('shop.home.discover.discoverBrands')}}</h2>
    </v-row>
    <v-row class="mb-3">
      <v-chip prepend-icon="mdi-lightbulb-outline" variant="flat" size="large"
        @click="showSheet = true, sheetType = 'businessFilter'" class="mr-4 px-4" color="default">
        {{$t('shop.home.discover.benefits')}}
      </v-chip>
      <v-chip prepend-icon="mdi-ribbon" variant="flat" size="large" @click="showSheet = true, sheetType = 'label'"
        class="mr-4 px-4" color="default">
        {{$t('shop.home.discover.value')}}
      </v-chip>
      <v-chip prepend-icon="mdi-flash-outline" variant="flat" size="large"
        @click="showSheet = true, sheetType = 'productGroup'" class="mr-4 px-4" color="default">
        {{$t('shop.home.discover.trend')}}
      </v-chip>
      <v-chip prepend-icon="mdi-grid" variant="flat" size="large"
        @click="showSheet = true, sheetType = 'productCategory'" class="mr-4 px-4" color="default">
        {{$t('shop.home.discover.category')}}
      </v-chip>
      <v-chip prepend-icon="mdi-earth" variant="flat" size="large" @click="showSheet = true, sheetType = 'Country'"
        class="mr-4 px-4" color="default">
        {{$t('shop.home.discover.location')}}
      </v-chip>
      <v-chip prepend-icon="mdi-magnify" variant="flat" size="large" @click="showSearch = true, sheetType = 'search'"
        class="mr-4 px-4" color="default">
        {{$t('shop.home.discover.search')}}
      </v-chip>
    </v-row>

    <CustomSlider :imageType="'slider'" :slides="recommendations" :wrap-around="false" :autoplay="5000"
      :loadNewEntries="handleNewEntries" />
    <v-row class="mb-10">
    </v-row>

    <v-row class="mb-2 mx-0">
      <h2>{{$t('shop.home.feed')}} </h2>
    </v-row>

    <MasonryGrid :items="streams" :max-columns="3" :min-columns="1">
      <!-- <template v-slot="{ item }">
          <CustomNewsCard :img="item.image" :item="item" :title="item.headline" :openPostPopup="() => openPost(item)">
          </CustomNewsCard>
      </template> -->
      <template #default="{ item }">
        <CustomPostCard :item="item" />
      </template>
    </MasonryGrid>
    <v-row justify="center" class="mt-3">
      <template v-if="loading">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>{{$t('global.common.loading.more')}}
      </template>
      <template v-else>
        <div>
          {{$t('global.common.loading.endOfStream')}}!
        </div>
      </template>
    </v-row>
    <div style="position: absolute;bottom: 40px;left: 50%;height: 40px;width: 40px;" v-intersect="infiniteScrolling">
    </div>


  </v-container>




  <CustomTopSheetDialog v-model="showSearch" :width="600">
    <template #title>
      <div class="d-flex align-center w-100">
        <v-icon @click="showSearch = false" icon="mdi-close" size="x-small" />
        <div class="flex-grow-1 text-center">
          <h3 class="flex-grow-1 text-center">{{$t('shop.home.discover.search')}}</h3>
        </div>
      </div>
    </template>

    <!-- <v-autocomplete v-model="selectedProducts" @update:search="onSearchProducts" variant="outlined" density="compact"
      :hide-details="true" :items="filteredProducts" item-title="name" return-object item-value="id" chips
      closable-chips multiple no-data-text="nichts ausgewählt" placeholder="nach weiteren Produktgruppen suchen...">
      <template v-slot:chip="{ item }">
        <v-chip label variant="flat" color="primary">
          {{ item.title }}
        </v-chip>
      </template>
    </v-autocomplete> -->

    <v-menu v-model="isSearchMenuOpen" location="bottom" class="search-bar" :close-on-content-click="false"
      :open-on-click="false">
      <template v-slot:activator="{ props, on }">
        <v-text-field v-on="on" v-bind="props" v-on:focus="isSearchMenuOpen = true" v-on:blur="handleBlur"
          v-model="search" variant="outlined" density="compact" :hide-details="true" @update:model-value="onSearch" :placeholder="$t('main.search.placeholder')">
          <template v-slot:prepend-inner >
            <v-icon class="">mdi-magnify</v-icon>
            <!-- <div color="default">
                  </div> -->
          </template>
        </v-text-field>
      </template>
      <v-card max-height="450">
        <v-list>
          <v-list-item v-if="searchResults.length < 1">
            <template v-slot:title>
              <h4> {{$t('main.search.noResults')}} </h4>
            </template>
            <template v-slot:append>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-list-item>
          <v-list-item class="clickable" @mousedown.prevent="selectSearchValue(entry)" v-for="entry in searchResults" :key="entry.id" v-else>
            <template v-slot:title>
              <h4> {{ entry.value }} </h4>
            </template>
            <template v-slot:subtitle>
              {{ $t(`search.${entry.type}`) }}
            </template>
            <template v-slot:append>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </CustomTopSheetDialog>


  <CustomTopSheetDialog v-model="showSheet" :width="600">
    <!-- Du hast bisher noch keine Nachrichten in deiner Inbox.
    Nach einer Anfrage kannst du hier deine Konversationen einsehen und beantworten. -->

    <template #title>
      <div class="d-flex align-center w-100">
        <v-icon @click="showSheet = false" icon="mdi-close" size="x-small" />
        <div class="flex-grow-1 text-center">
          <h3 class="flex-grow-1 text-center">{{ !showProducers ?
            $t(`home.discover.modal.heading.${sheetTitleTranslation}`) : `Gefundene Hersteller für:
            ${selectedCompanyFilter.name ? selectedCompanyFilter.name : selectedCompanyFilter.value ? selectedCompanyFilter.value : selectedCompanyFilter.frontendImageName}` }}</h3>
        </div>
      </div>
    </template>
    <v-list v-if="!showProducers" class="dense-list" lines="one" active-class="" variant="text" density="compact"
      bg-color="transparent">
      <v-list-item v-for="(item, index) in sheetItems" :key="index" :ripple="false" class="py-0 dialog-list-item"
        @click="openProducerList(item)">
        <v-list-item-title v-if="sheetType == 'businessFilter'">{{
          item.nameTranslations[selectedLanguage.toUpperCase()]
        }}</v-list-item-title>
        <v-list-item-title
          v-else-if="sheetType == 'label' || sheetType == 'productGroup' || sheetType == 'productCategory'">{{
            item.translations[selectedLanguage.toUpperCase()].value
          }}</v-list-item-title>
        <v-list-item-title v-else-if="sheetType == 'Country'">{{ item.translations[selectedLanguage.toUpperCase()]
        }}</v-list-item-title>
        <template v-slot:append>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-list-item>
    </v-list>
    <v-list v-else-if="showProducers" lines="one" active-class="" variant="text" bg-color="transparent">
      <v-list-item v-for="(item, index) in producers" :key="index" :ripple="false"
        class="py-0 px-0 dialog-list-item mb-2" @click="openProfile(item.id)">
        <template v-slot:prepend>
          <v-responsive max-height="80" max-width="160" class="mr-2">
            <img height="72px" :src="`${$cloudFrontApi}${item.assets[0]}/GALLERY_IPHONE6`" cover />
          </v-responsive>
        </template>
        <template v-slot:title>
          {{ item.name }}
        </template>
        <template v-slot:subtitle>
          {{ item.tagline }}
        </template>
        <template v-slot:default>
          {{ item.countryOfOrigin }}
        </template>
      </v-list-item>
    </v-list>
  </CustomTopSheetDialog>
</template>

<script>
// import { ref } from 'vue';
import CustomTopSheetDialog from '../custom/CustomTopSheetDialog.vue';
import CustomerSliderImage from '../custom/CustomSliderImage.vue';
import CustomPostCard from '../custom/CustomPostCard.vue';
import CustomSlider from '../custom/CustomSlider.vue';
import MasonryGrid from '../custom/MasonryGrid.vue';
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';

export default {
  components: {
    CustomTopSheetDialog,
    CustomSlider,
    CustomerSliderImage,
    CustomPostCard,
    MasonryGrid
  },
  setup() {
    const showSheet = ref(false);
    const showSearch = ref(false)
    const config = {
      itemsToShow: 3
    }
    const { proxy } = getCurrentInstance();
    const showProducers = ref(false);
    const producers = ref([]);
    const sheetType = ref('')
    const router = useRouter();
    // const selectedLanguage = inject('selectedLanguage', selectedLanguage);
    const selectedLanguage = localStorage.getItem('selectedLanguage');

    const selectedCompanyFilter = ref(null)
    const openProducerList = async (param) => {
      var filter;
      if (sheetType.value == 'Country') {
        filter = { ['countryCodes']: [param.code] };
      } else {
        filter = { [`${sheetType.value}Ids`]: [param.id] };
      }
      const hardToken = localStorage.getItem("hardToken");
      const username = localStorage.getItem("username");

      selectedCompanyFilter.value = param;


      try {
        const response = await proxy.$axios.post("/merchant/query",
          filter,
          {
            headers: {
              'X-Auth-HARDTOKEN': hardToken,
              'X-Auth-USER': username
            },
          },
        );
        showProducers.value = true;
        if (response.data.status == "OK") {
          producers.value = response.data.data
        }
      } catch (error) {
        console.error("Error: ", error);
      }

    }

    const getTrendingCountries = (trendingMerchantCountries, countries) => {
      return Object.keys(trendingMerchantCountries)  // Get the country codes from the trendingMerchantCountries object
        .map(code => countries[code])               // Map each code to its corresponding country object from 'countries'
        .filter(country => country !== undefined);   // Filter out undefined values if the country is not found
    };
    const search = ref('');
    const isSearchMenuOpen = ref(false)
    const searchResults = ref([])

    const handleBlur = (event) => {
      // Delay closing to check if focus moves inside the menu
      setTimeout(() => {
        isSearchMenuOpen.value = false;
        // if (!event.relatedTarget || !event.relatedTarget.closest('.search-bar')) {
        // }
      }, 100);
    };
    const onSearch = async (event) => {
      const hardToken = localStorage.getItem("hardToken");
      const username = localStorage.getItem("username");
      const softToken = localStorage.getItem("softToken");
      if (event.length >= 2) {
        try {
          const response = await proxy.$axios.get("/search/merchant/keywords",
            {
              headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
              },
              params: {
                keyword: event,
                lang: selectedLanguage.toUpperCase()
              }
            },
          );
          if (response.data.status == "OK") {
            searchResults.value = response.data.data;
          }
        } catch (error) {
          console.error("Error: ", error);
        }
      }
    }
    const selectSearchValue = (entry) => {
      nextTick(() => {
        search.value = entry.value; // Assign value after DOM update
      });
      if(entry.type == "MERCHANT_NAME") {
        router.push(`/fairling/${entry.id}/`)
        return;
      }
      sheetType.value = 'productGroup';
      openProducerList(entry);
      showSheet.value = true;
    }

    return {
      showSheet,
      config,
      openProducerList,
      producers,
      showProducers,
      selectedLanguage,
      sheetType,
      getTrendingCountries,
      showSearch,
      onSearch,
      searchResults,
      isSearchMenuOpen,
      search,
      handleBlur,
      selectedCompanyFilter,
      selectSearchValue
    };
  },

  watch: {
    showSheet(newValue) {
      // Adjust width based on filter value
      if (!newValue) {
        this.showProducers = false;
        this.producers = [];
      }
    },
  },

  data() {
    return {
      sliderPage: 0,
      sliderResultsPerPage: 15,
      sliderTotalPages: 0,
      streamPage: 0,
      streamResultsPerPage: 8,
      streamTotalPages: 0,
      loading: false,
      // showSheet: false,
      gridItems: [1, 2, 3, 4, 6, 7, 8, 9],
      businessfilters: [],
      labels: [],
      productGroups: [],
      productCategories: [],
      countries: [],
      recommendations: [],
      streams: [],
      items: [
        "Kundenmagnet",
        "Image Booster",
        "Must-Have",
        "Geheimtipp",
        "Margen-Held",
        "PR-Star",
        "Kundenliebling",
        "Durchstarter",
      ],
    }
  },

  computed: {
    sheetItems() {
      // Dynamically generate the path for the icon
      switch (this.sheetType) {
        case 'businessFilter':
          return this.businessfilters

        case 'label':
          return this.labels.filter(label => !label.name.includes("Made in"));
        case 'productGroup':
          return this.productGroups;
        case 'productCategory':
          return this.productCategories;
        case 'Country':
          return this.getTrendingCountries(this.trendingMerchantCountries, this.countries)
        default:
          return []
      }
    },
    sheetTitleTranslation() {
      switch (this.sheetType) {
        case 'businessFilter':
          return "benefits"
        case 'label':
          return "value";
        case 'productGroup':
          return "trend"
        case 'productCategory':
          return "category"
        case 'Country':
          return "location"
        default:
          return []
      }
    }
  },

  mounted() {
    this.fetchBusinessfilters();
    this.fetchLabels();
    this.fetchProductGroups();
    this.fetchProductCategories();
    this.fetchCountryData();
    this.fetchTrendingMerchantCountriesData();
    this.fetchRecommendations();
    this.fetchStreams();
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting && this.loading == false) {
        this.loading = true;
        setTimeout(() => {
          var _this = this;
          if (this.streamPage < this.streamTotalPages) {
            this.streamPage++;

            const hardToken = localStorage.getItem("hardToken");
            const softToken = localStorage.getItem("softToken");
            const username = localStorage.getItem("username");
            this.$axios.get("/merchant/fair/streams", {
              headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
              },
              params: {
                page: this.streamPage,
                resultsPerPage: this.streamResultsPerPage,
              }
            })
              .then((response) => {
                if (response.data.data.length > 1) {
                  _this.streams = [..._this.streams, ...response.data.data]
                  // response.data.data.forEach((item) =>
                  // );
                }
                _this.loading = false;
              })
              .catch(error => {
                
                // You can handle specific error codes here, for example, a 401 Unauthorized
                if (error.response && error.response.status === 401 || error.response.status === 403) {
                  // Handle token expiration or unauthorized error
                  console.log("Session expired or unauthorized. Please log in again.");
                  _this.$router.replace('/login');
                  // Optionally log the user out or redirect to login page
                }
              });
          }
        }, 500);
        this.loading = false;
      }
    },
    handleNewEntries() {
      this.infiniteSliding();
    },
    infiniteSliding() {
      // if (this.sliderPage < this.sliderTotalPages) {
      this.sliderPage++;

      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("/merchant/recommend", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
        params: {
          activeOnly: true,
          page: this.sliderPage,
          resultsPerPage: this.sliderResultsPerPage,
          sortDirection: 'DESC',
        }
      })
        .then((response) => {
          if (response.data.data.length > 1) {
            _this.recommendations = [..._this.recommendations, ...response.data.data]
            // response.data.data.forEach((item) =>
            // );
          }
        })
        .catch(error => {
          
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
      // }
    },
    fetchRecommendations() {

      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("/merchant/recommend", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
        params: {
          activeOnly: true,
          page: this.sliderPage,
          resultsPerPage: this.sliderResultsPerPage,
          sortDirection: 'DESC',
        }
      })
        .then(this.recommendationsFechted)
        .catch(error => {
          
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    recommendationsFechted(response) {
      this.recommendations = response.data.data;
      this.sliderTotalPages = response.data.totalPages;
    },
    fetchStreams() {
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      this.loading = true;
      var _this = this;
      this.$axios.get("/merchant/fair/streams", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
        params: {
          page: this.streamPage,
          resultsPerPage: this.streamResultsPerPage,
        }
      })
        .then(this.streamsFechted)
        .catch(error => {
          
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    streamsFechted(response) {
      this.streams = response.data.data;
      this.streamTotalPages = response.data.totalPages;
      this.loading = false;
    },
    fetchLabels() {
      // const softToken = localStorage.getItem("softToken");
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("/public/data/labels", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
      })
        .then(this.labelsFetched)
        .catch(error => {
          
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    labelsFetched(response) {
      if (response.data.status == "OK") {
        this.labels = response.data.data
      }
    },
    fetchBusinessfilters() {
      // const softToken = localStorage.getItem("softToken");
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("/public/data/businessfilters", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
      })
        .then(this.businessfiltersFetched)
        .catch(error => {
          
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    businessfiltersFetched(response) {
      if (response.data.status == "OK") {
        this.businessfilters = response.data.data
      }
    },
    fetchProductGroups() {
      // const softToken = localStorage.getItem("softToken");
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("/merchant/productGroups/sub", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
        params: {
          page: 0,
          resultsPerPage: 15
        }
      })
        .then(this.productGroupFetched)
        .catch(error => {
          
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    productGroupFetched(response) {
      if (response.data.status == "OK") {
        this.productGroups = response.data.data
      }
    },
    fetchProductCategories() {
      // const softToken = localStorage.getItem("softToken");
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("/merchant/productCategories", {
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        },
        params: {
          page: 0,
          resultsPerPage: 10
        }
      })
        .then(this.productCategoriesFetched)
        .catch(error => {
          
          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    productCategoriesFetched(response) {
      if (response.data.status == "OK") {
        this.productCategories = response.data.data
      }
    },
    fetchTrendingMerchantCountriesData() {
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      this.$dataAxios.get("/trendingMerchantCountries.json",{
        headers: {
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username,
          'Authorization': ''
        }
      })
        .then(this.countryDataFetched)
        .catch()
    },
    fetchCountryData() {
      const hardToken = localStorage.getItem("hardToken");
      const softToken = localStorage.getItem("softToken");
      const username = localStorage.getItem("username");
      this.$dataAxios.get("/countrydata.json",{
        headers: {
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username,
          'Authorization': ''
        }
      })
        .then(response => this.countries = response.data)
        .catch()
    },
    countryDataFetched(response) {
      this.trendingMerchantCountries = response.data;
    },
    openProfile(id) {
      this.$router.push(`/fairling/${id}/`);
    },
  },
};
</script>

<style scoped>
.inner-main {
  margin-left: auto;
  margin-right: auto;
  max-width: 1170px;
  margin-top: 40px;
}

/*.dialog-list-item {
  min-height: 30px !important;
  background-color: transparent !important;
}

.v-list-item:hover {
  background-color: transparent !important;
}*/
</style>

<style>
.v-chip__content {
  font-size: 14px !important;
}

.dense-list .v-list-item {
  min-height: 20px !important;
}

.dense-list .v-list-item-title {
  font-size: 12px;
  letter-spacing: 1px;
}
</style>
